import React, { useState, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Upload from '../../assets/icons/Upload';
import { notification } from 'antd';
import BigDoc from '../../assets/icons/BigDoc';
import Docs from '../../assets/icons/Docs';
import { updateContentUpload } from '../../services/handleImage';

const UpdateDoc = ({
  id,
  selectedContent,
  schoolId,
  courseId,
  topicId,
  lessonId,
}) => {
  const [docTitle, setDocTitle] = useState(selectedContent?.title);
  const [docUrl, setDocUrl] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [activity, setActivity] = useState(false);
  const [file, setFile] = useState('');
  const [progress, setProgress] = useState(0);

  const handleDocTitle = (e) => {
    setDocTitle(e.target.value);
  };

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  const activityTag = () => {
    return (
      <>
        <div className='activity-tag'>
          <svg
            width='14'
            height='12'
            viewBox='0 0 14 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M13.6673 5.33333V0H9.00065V2H5.00065V0H0.333984V5.33333H5.00065V3.33333H6.33398V10H9.00065V12H13.6673V6.66667H9.00065V8.66667H7.66732V3.33333H9.00065V5.33333H13.6673ZM3.66732 4H1.66732V1.33333H3.66732V4ZM10.334 8H12.334V10.6667H10.334V8ZM10.334 1.33333H12.334V4H10.334V1.33333Z'
              fill='#4CC5EC'
            />
          </svg>

          <p>Activity</p>
        </div>
      </>
    );
  };

  const handleCheck = (e) => {
    setActivity(e.target.checked);
  };
  //upload doc on drop
  const {
    getRootProps: getRootDocProps,
    getInputProps: getInputDocProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop: async (acceptedFiles) => {
      //saved titles

      if (!docTitle) {
        notification['error']({
          message: 'Doc title is required',
        });
        return;
      }

      setFile(acceptedFiles[0]);

      setDocUrl([
        ...docUrl,
        {
          name: acceptedFiles[0].name,
          preview: URL.createObjectURL(acceptedFiles[0]),
        },
      ]);

      try {
        setUploading(true);

        let res = await updateContentUpload(
          selectedContent?.sn,
          docTitle,
          90,
          'doc',
          activity,
          acceptedFiles[0],
          '',
          schoolId,
          courseId,
          topicId,
          lessonId,
          '',
          (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
          },
          selectedContent.id
        );
        setUploading(false);
        notification['success']({
          message: res.data,
        });
      } catch (error) {
        console.log(error.response);
        setUploading(false);
        notification['error']({
          message: error?.response?.data?.data?.errors?.file[0],
        });
      }
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );
  return (
    <div className='add-course__content-wrap'>
      <label
        className='add-course__content-selection__head'
        style={{ marginBottom: '16px' }}
      >
        <div
          className='add-course__content-selection__head__title'
          style={{ display: 'flex', gap: '16px' }}
        >
          {' '}
          <p>Update Document Title</p>
          {activity && activityTag()}
        </div>
      </label>

      <div
        className='auth-wrapper__right__form__inputwrapper eye-position'
        style={{ width: '100%' }}
      >
        <input
          type='text'
          name='docTitle'
          id='docTitle'
          onChange={handleDocTitle}
          value={docTitle}
          placeholder='Enter a title for this document'
        />
        <div className='eye-icon'></div>
        <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
          max of 80 characters
        </p>
      </div>

      <div className='dropzone-video'>
        {uploading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <label htmlFor='progress-bar'>{progress}%</label>
            <progress id='progress-bar' value={progress} max='100'></progress>
          </div>
        ) : docUrl.filter((el) => el.id === id).length > 0 ? (
          <>
            <div className='video-preview'>
              <div className='video-preview__audio'>
                <BigDoc />
              </div>
              <div className='video-preview__video-details'>
                <div className='video-preview__video-details__icon'>
                  <Docs />
                </div>
                <p>{docUrl.filter((el) => el.id === id)[0]?.name}</p>
              </div>
            </div>
            <div
              className='replace-vid'
              onClick={() => setDocUrl(docUrl.filter((el) => el.id !== id))}
            >
              <Upload />
              <p>Replace Document</p>
            </div>
          </>
        ) : (
          <div className='container'>
            <div
              {...getRootDocProps({
                style,
                onDrop: (event) => () => localStorage.setItem('itemId', id),
                onClick: () => localStorage.setItem('itemId', id),
              })}
            >
              <input {...getInputDocProps()} />
              <Upload />
              <p>Drag and drop document or </p>
              <p className='sec-text'> Upload from your computer</p>
            </div>
          </div>
        )}
      </div>

      <div className='add-course__text-editor__cancel'>
        <div className='activity-check'>
          <input type='checkbox' onChange={handleCheck} name='document' />
          <p>Check the box if this is an activity for students</p>
        </div>
      </div>
    </div>
  );
};

export default UpdateDoc;
